export default "__VITE_ASSET__C_rFH5a7__"